module.exports = __webpack_public_path__ + "static/media/saudi-arabia.497d51c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/saudi-arabia.svg
// module id = 371
// module chunks = 1